const reduceFormData = (prev: FormDataEntryValue[], [key, untrimmedValue]: [string, string]) => {
    const value = untrimmedValue.trim();
    return { ...prev, [key]: value };
};

// @ts-ignore
export default (form: HTMLFormElement) => [...new FormData(form).entries()].reduce(reduceFormData, {});
